import { forwardRef } from 'react';
import type { TextBlockProps } from '../text';
import { TextBlock } from '../text';

export type HeadingBlockProps = TextBlockProps;

export const HeadingBlock = forwardRef<HTMLDivElement, HeadingBlockProps>(
  (props, forwardingRef) => <TextBlock {...props} ref={forwardingRef} />
);
